@if (careerValuation) {
    <div class="d-flex gap-1 align-items-baseline">
        <span adaptTooltip="Career Valuation"
              class="cvt-link-badge"></span>
        @if (!linkDisabled) {
            <a (click)="openCareerValuation($event)"
               class="text-break cvt-link"
               data-test="cvt-link-summary"
               href="#"
               target="_blank">{{ careerValuation.extensions.linkText }} </a>
        } @else {
            <span data-test="cvt-plain-text-link-summary">{{ careerValuation.extensions.linkText }}</span>
        }
        @if (canEdit && hasEditPermission) {
            <button class="btn btn-link"
                    [adaptBlockingClick]="deleteLink"
                    adaptTooltip="Delete link"
                    data-test="cvt-link-delete"
                    adaptButtonIcon="fal fa-fw fa-trash-alt"></button>
        }
    </div>
}
